import { toJalaali } from "jalaali-js";

export const formatJalaliDate = (value, { showTime = false } = {}) => {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";
  const jalali = toJalaali(
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
  );
  const datePart = `${jalali.jy}/${String(jalali.jm).padStart(2, "0")}/${String(
    jalali.jd,
  ).padStart(2, "0")}`;
  if (!showTime) return datePart;
  const timePart = date.toLocaleTimeString("en-US", {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  return `${datePart} ${timePart}`;
};

export const paidOrderTagTitle = (order) => {
  const parts = [
    order?.productTitle,
    formatJalaliDate(order?.payDate, { showTime: true }),
  ].filter(Boolean);
  return parts.length ? parts.join(" - ") : undefined;
};

const JalaliDateCell = ({
  lead,
  date: rawDate,
  showTime = true,
  fallback = "-",
}) => {
  const formatted = formatJalaliDate(rawDate ?? lead?.createdAt, { showTime });
  return <span dir="ltr">{formatted || fallback}</span>;
};

export default JalaliDateCell;
